import config from '@/etc/rosepetal.json';

const vertexs = {
    getConfig() { return config.firebaseConfig },
}

const install = app => { app.config.globalProperties.$vertexs = vertexs; };

export { install as default, vertexs as vertex };